import { Router } from '@angular/router';

declare function doPOST(url: string, data: any): Promise<any>;

export class HelpMeClient {
  static endpointURL: string = 'http://localhost:8082/';

  _STATUS_NONE: number = 0;
  _STATUS_WAITING: number = 1;
  _STATUS_JOINED: number = 2;
  _STATUS_INPROGRESS: number = 3;
  _STATUS_ENDED: number = 3;

  private static client: HelpMeClient | undefined;

  private _status: number = this._STATUS_NONE;

  private _sessionId: string = '';
  private _clientId: string = '';

  private router: Router | undefined = undefined;

  private updateFrequencyMillis = 300;
  private _receiveEventsIntervalId = 0;

  private pollId: number | undefined = undefined;
  private static INTERVAL_LISTEN_FOR_REQUEST: number = 3000;

  //private _heardRequestCallback: any;
  private _caller: any;

  private pointer: any = null;
  //private pointerSize: any = null;
  //private receivePositionInProgress: boolean = false;
  private receiveClickInProgress: boolean = false;

  //private _supportUserId:string = "";
  //private _guestId:string = "";

  get sessionId() {
    return this._sessionId;
  }

  constructor(data: any) {
    this._sessionId = data.sessionId;
    //this._heardRequestCallback = data.callback;
    this._caller = data.caller;
    this._clientId = data.clientId;
  }

  /*
    // Factory
    static getClient(sessionId: string): HelpMeClient {
        if (HelpMeClient.client != undefined) {
            return HelpMeClient.client;
        }
        else {
            return new HelpMeClient({sessionId:sessionId});
        }
    }
    */

  public static initialize(clientId: string, caller: any) {
    console.log('Initializing client...');
    HelpMeClient.client = new HelpMeClient({
      clientId: clientId,
      caller: caller,
    });
    HelpMeClient.client.startListeningForRequest();
    return HelpMeClient.client;
  }

  private startListeningForRequest() {
    let that = this;
    this.pollId = window.setInterval(function () {
      that.listenForRequest();
    }, HelpMeClient.INTERVAL_LISTEN_FOR_REQUEST);
    console.log('HelpMe! Client is listening for incoming requests to join...');
  }

  private stopListeningForRequest() {
    window.clearInterval(this.pollId);
    this.pollId = 0;
  }

  private async listenForRequest() {
    console.log('Looking for session for client ' + this._clientId + '...');

    HelpMeClient.client = await HelpMeClient.getPendingSession(this._clientId);

    if (HelpMeClient.client != undefined) {
      this._sessionId = HelpMeClient.client?.sessionId;

      console.log(
        'Client heard invite for session #' + HelpMeClient.client.sessionId,
      );

      this.stopListeningForRequest();

      this._caller.heardInvite(this);
    }
  }

  async joinSession(
    pointer: any,
    pointerSize: any,
    router: Router,
  ): Promise<void> {
    if (HelpMeClient.client == undefined) {
      throw 'Client is not initialized';
    }

    console.log('Joining session #' + this._sessionId);

    this.router = router;

    let screenWidth = window.screen.availHeight;
    let screenHeight = window.screen.availWidth;

    await HelpMeClient._joinSessionAPI(
      this._sessionId,
      this.router.url,
      screenWidth,
      screenHeight,
    );

    this._status = this._STATUS_JOINED;
    this.pointer = pointer;

    this.startListeningForUIEvents();
  }

  private startListeningForUIEvents() {
    if (this._receiveEventsIntervalId == 0) {
      var that = this;
      this._receiveEventsIntervalId = window.setInterval(function () {
        that._receiveUIEventsAPI();
      }, this.updateFrequencyMillis);
      console.log('Client is now listening for UI events');
    }
  }

  private stopListeningForUIEvents() {
    window.clearInterval(this._receiveEventsIntervalId);
    this._receiveEventsIntervalId = 0;
    this.pointer.nativeElement.setAttribute('style', 'display:none');
  }

  async endSession() {
    this.stopListeningForUIEvents();

    this._status = this._STATUS_ENDED;

    console.log('Ended session. Listening for new requests.');

    this.startListeningForRequest();

    this._caller.endedSessionCallback(this);
  }

  static async getPendingSession(
    clientId: string,
  ): Promise<HelpMeClient | undefined> {
    let sessionId = await this._getSessionByClientIdAPI(clientId);

    if (sessionId != undefined) {
      HelpMeClient.client = new HelpMeClient({ sessionId: sessionId });
      return HelpMeClient.client;
    } else {
      return undefined;
    }
  }

  private movePointer(position: any) {
    const x = position.x - this.pointer.nativeElement.width;
    const y = position.y - this.pointer.nativeElement.height / 2;

    this.pointer.nativeElement.setAttribute(
      'style',
      'position: absolute; left:' + x + 'px; top:' + y + 'px',
    );
  }

  static async _joinSessionAPI(
    sessionId: string,
    currentURL: string,
    screenWidth: number,
    screenHeight: number,
  ): Promise<boolean> {
    let data = {
      sessionId: sessionId,
      url: currentURL,
      screenWidth: screenWidth,
      screenHeight: screenHeight,
    };

    let json = await doPOST(HelpMeClient.endpointURL + 'joinSession', data);

    if (json.isJoined) {
      return true;
    } else {
      throw 'Server error while joining session';
    }
  }

  static async _getSessionByClientIdAPI(
    clientId: string,
  ): Promise<string | undefined> {
    let data = {
      clientId: clientId,
    };

    let json = await doPOST(
      HelpMeClient.endpointURL + 'getSessionByClientId',
      data,
    );

    if (json.session != null && json.session.sessionId != '') {
      return json.session.sessionId;
    }
    return undefined;
  }

  async _receiveUIEventsAPI() {
    if (!this.receiveClickInProgress) {
      this.receiveClickInProgress = true;

      let data = {
        sessionId: this.sessionId,
      };

      try {
        doPOST(HelpMeClient.endpointURL + 'receiveUIEventQueue', data).then(
          (response) => {
            if (response) {
              if (!response.sessionIsActive) {
                this.endSession();
              } else if (response.events) {
                for (var i = 0; i < response.events.length; i++) {
                  if (response.events[i].eventType == 'position') {
                    this.movePointer(response.events[i].position);
                  } else if (response.events[i].eventType == 'click') {
                    //clickElement(response.events[i].clientId);
                    console.log('Handling click event');
                  } else if (response.events[i].eventType == 'keyup') {
                    //setElementText(response.events[i].clientId, response.events[i].text);
                    console.log('Setting text');
                  }
                }
              }
            }
          },
        );
      } catch (error) {
        console.log('Error receiving event: ' + error);
      }

      this.receiveClickInProgress = false;
    }
  }
}
